<template>
  <div class="primary">
    <Toast />
    <ConfirmPopup
      class="fixed w-[400px] top-[200px] left-0 right-0 mx-auto before:hidden after:hidden shadow-none rounded-[10px] !z-[1111]">
    </ConfirmPopup>
    <CreatePostModal v-if="userdata" v-model:isShow="isShow" is-close-active :main-title="'Compose'"
      :user-data="userdata">
    </CreatePostModal>
    <CreateOrgPostModal v-if="userdata" v-model:isShow="isShowOrgModal" is-close-active :main-title="'Compose'"
      :user-data="userdata">
    </CreateOrgPostModal>

    <div class="primary__inner grid">
      <Header />
      <!-- <div class="center-right-wrapper"> -->
      <div class="sm:flex block flex-row gap-5 justify-center main-container">
        <Leftbar />
        <div class="centerbar-surface">
          <RouterView class="primary__content stable-router-view" />
        </div>
        <div class="rightbar-host" v-if="showRightbar">
          <Rightbar />
        </div>
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>

<script setup>
console.log("Top-level log in Leftbar.vue");
import { computed, onBeforeUnmount, onMounted, ref, defineAsyncComponent } from 'vue';

import ConfirmPopup from 'primevue/confirmpopup';
import Toast from 'primevue/toast';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

import Header from '@/components/Header/index.vue';
import Leftbar from '@/components/Leftbar/index.vue';
import Rightbar from '@/components/Rightbar/index.vue';
import { debounce } from '@/utils/debounce.js';

import AboutUs from '../components/AboutUs/index.vue';
const CreatePostModal = defineAsyncComponent(() => import('../components/modals/createPostModal.vue'));
const CreateOrgPostModal = defineAsyncComponent(() => import('../components/modals/OrgModals/createPostOrg.vue'));
import { useToast } from 'primevue/usetoast';

const store = useStore();
const toast = useToast();
const router = useRouter();
const isMobile = ref(false);
const showRightbar = ref(true);
const isShow = computed(() => store.getters.getShowModalStatus);
const isShowOrgModal = computed(() => store.getters.getOrgShowModalStatus);
const isShowReply = computed(() => store.getters.getShowModalReplyStatus);
const userdata = computed(() => store.getters.getUser);

// Intelligent responsive breakpoint detection
const checkResponsiveLayout = () => {
  const width = window.innerWidth;
  isMobile.value = width <= 500; // Mobile navigation appears
  showRightbar.value = width > 1000; // Rightbar disappears at 1000px to protect centerbar
};

const debouncedResponsiveCheck = debounce(checkResponsiveLayout, 100);
/** @type {(this: Window, ev: UIEvent) => any} */
const onResize = () => debouncedResponsiveCheck();

onMounted(async () => {
  checkResponsiveLayout();
  window.addEventListener('resize', onResize);

  // Preload modal components shortly after mount to speed up first open
  const preloadModals = () => {
    import('../components/modals/createPostModal.vue');
    import('../components/modals/OrgModals/createPostOrg.vue');
  };
  if ('requestIdleCallback' in window) {
    // @ts-ignore - requestIdleCallback may not be typed
    window.requestIdleCallback(preloadModals, { timeout: 2000 });
  } else {
    setTimeout(preloadModals, 1500);
  }
});
onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize);
});
</script>

<style lang="scss">
.primary {
  // margin: 0 auto;
  /* Use theme gradient variables so dark mode is not washed out */
  background: var(--app-background-gradient, linear-gradient(135deg, var(--background-primary) 0%, var(--background-secondary) 100%));
  // max-width: var(--app-max-width); // Use centralized variable (1288px or viewport)
  // width: 100%; // Fill available space up to max-width
  min-width: var(--layout-min-width); // Prevent shrinking below usable size - forces horizontal scroll
  height: 100vh;
  /* Lock viewport height */
  min-height: 100vh;
  overflow: hidden;
  /* Disable page-level scroll */
  position: relative;

  &__content {
    flex-grow: 1;
    max-width: var(--centerbar-width); // Use centralized variable
    width: 100%;
  }

  // Simplified grid layout using centralized variables
  &__inner {
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items: anchor-center;
    gap: 2rem;
    // grid-template-columns: var(--grid-leftbar-column) 1fr;
    /* Create space for fixed header */
    // padding-top: var(--header-height);
    // gap: var(--layout-grid-gap);
    height: 100%;
    /* Fill remaining app viewport */
    min-height: 0;
    /* Allow children to shrink for internal scroll */
    overflow: hidden;
    /* No page-level scroll */
    box-sizing: border-box;
    /* Include header padding inside height */
    position: relative;

    // width: 100%;
    /* Use full app width */
    // min-width: 0;
    /* Allow grid items to shrink */
    // grid-template-areas: "leftbar center-right";
    /* Explicit areas for clarity */
    // background-color: #DFEFFF;
  }

  .center-right-wrapper {
    display: flex;
    flex-direction: row;
    // align-items: flex-start;
    // width: 100%;
    height: 100%;
    min-height: 0;
    /* Critical for nested scroll containers */
    overflow: hidden;
    /* Prevent bubbling scroll to page */
    position: relative;
    // flex-wrap: nowrap;
    /* Never allow wrapping */
    min-width: 0;
    /* Allow shrinking */
    z-index: 0;
    /* Keep under the sticky leftbar */
  }

  /* When viewport is narrow enough that rightbar is hidden, let centerbar fill remaining space smoothly */
  @media (max-width: 1000px) {
    .center-right-wrapper {
      justify-content: stretch;
      /* keep left aligned but allow full stretch */
      gap: 0;
    }

    .centerbar-surface {
      flex: 1 1 auto;
      /* allow it to grow and shrink */
      max-width: 100%;
      /* remove fixed cap */
      width: 100%;
      /* fill the available 1fr column */
      // flex-shrink: 1;
      /* permit shrinking with viewport */
    }

    /* Expand the routed content to fill centerbar when rightbar is hidden */
    .primary__content {
      flex: 1 1 auto;
      max-width: 100%;
      width: 100%;
    }
  }

  /* On very narrow screens (mobile), hide leftbar completely */
  @media (max-width: 360px) {
    .primary__inner {
      grid-template-columns: 1fr;
      /* Single column layout */
      grid-template-areas: "center-right";
      /* Only center-right area */
    }

    .center-right-wrapper {
      width: 100%;
    }

    .centerbar-surface {
      flex: 1 1 auto;
      max-width: 100%;
      width: 100%;
    }

    .primary__content {
      flex: 1 1 auto;
      max-width: 100%;
      width: 100%;
    }
  }

  /* Routed view should fill available vertical space and allow nested scroll containers */
  .primary__content {
    flex: 1 1 auto;
    /* take remaining height within centerbar-surface (column flex) */
    min-height: 0;
    /* critical: allow children to define their own scroll areas */
    width: 100%;
    /* match centerbar-surface width */
    max-width: 100%;
  }

  .centerbar-surface {
    // flex: 0 0 var(--centerbar-width);
    // max-width: var(--centerbar-width);
    width: 57%;
    height: 100%;
    /* Fill column height */
    // min-height: 0;
    /* Allow its children to become scroll containers */
    // display: flex;
    // flex-direction: column;
    overflow-y: hidden;
    /* Disable page scroll; inner views should scroll themselves */
    overflow-x: hidden;
    /* Prevent horizontal bleed */
    background: transparent;
    /* Use transparent to show app background gradient like sidebars */
    position: relative;
    /* Raise above rightbar__inner (z-index: 10) so centerbar overlays aren’t covered */
    z-index: 20;
    /* Ensure centerbar appears above rightbar overlay content */
    padding-top: 0;
    /* Remove padding to extend to browser edge */
    // min-width: 0;
    /* Allow shrinking when squeezed */
    // flex-shrink: 0;
    /* Protect centerbar from shrinking initially */
    /* No margin - centerbar and rightbar should be adjacent */
  }

  .rightbar-host {
    // flex: 1;
    // display: flex;
    // flex-direction: column;
    // justify-content: start;
    // margin-top: 3rem;
    /* Take remaining space to align with page edge */
    // min-width: var(--rightbar-width);
    max-width: none;
    /* Allow it to extend to page edge */
    height: 100%;
    /* Take full height */
    // display: flex;
    // flex-direction: column;
    // overflow-y: hidden;
    /* Do not scroll outer rightbar */
    // overflow-x: hidden;
    /* Prevent rightbar content from overflowing */
    position: relative;
    // flex-shrink: 1;
    /* Allow shrinking when squeezed */
    // flex-wrap: nowrap;
    /* Never wrap content */
    width: 23%;

    /* Ensure rightbar content doesn't exceed its container */
    * {
      max-width: 100%;
      box-sizing: border-box;
    }
  }

  /* Media query fallback for hiding rightbar (align with JS toggle at 1000px) */
  @media (max-width: 1000px) {
    .rightbar-host {
      display: none !important;
    }
  }

  // Responsive breakpoints using centralized system
  @include _1300 {
    &__inner {
      // padding-right: 20px;
    }
  }

  @include _1279 {
    &__inner {
      // grid-template-columns: var(--leftbar-width-1279) 1fr;
      // padding: var(--layout-padding-top) var(--layout-padding-horizontal) 0;
      // height: 100%;
      // box-sizing: border-box;
    }

    .rightbar-host {
      flex: 1 1 auto;
      max-width: none;
    }
  }

  @include _1024 {
    &__inner {
      // grid-template-columns: var(--leftbar-width-1024) 1fr;
      // padding: var(--layout-padding-top) var(--layout-padding-horizontal) 0;
    }

    /* Do not hide rightbar here; we hide it at 1000px to match JS toggle */
    .centerbar-surface {
      padding-top: 0;
      /* Remove padding to extend to browser edge */
    }
  }

  @include _810 {
    &__inner {
      grid-template-columns: var(--leftbar-width-810) 1fr;
    }
  }

  @include _767 {
    &__inner {
      grid-template-columns: var(--leftbar-width-767) 1fr;
    }
  }

  @include _639 {
    &__inner {
      // grid-template-columns: 1fr; // Single column, hide leftbar
      // padding: var(--layout-padding-top) var(--layout-padding-horizontal) 0;
      // height: 100%;
      // box-sizing: border-box;
    }
  }

  /* Reassert ≤1000px behavior after base rules to avoid any cascade overrides */
  @media (max-width: 1000px) {
    .center-right-wrapper {
      gap: 0;
      justify-content: stretch;
    }

    .centerbar-surface {
      flex: 1 1 auto;
      max-width: 100%;
      width: 100%;
      flex-shrink: 1;
      z-index: 0;
      /* Keep below sticky leftbar to avoid overlap */
    }

    .primary__content {
      flex: 1 1 auto;
      max-width: 100%;
      width: 100%;
    }
  }
}

// Prevent layout shifts during route transitions
.stable-router-view {
  width: 100%;
  contain: layout;
  isolation: isolate;
  position: relative;
}

.p-toast {
  position: fixed !important;
  top: 30px !important;
  left: 0 !important;
  right: 0 !important;
  margin-left: auto !important;
  margin-right: auto !important;
  max-width: 100%;
  z-index: 4000 !important;
}

.wrap-confirm {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: table;
}
</style>
